var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as Const from "@utils/Const";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { useNavigate } from "react-router-dom";
export default function () {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    let token = localStorage.getItem(Const.TOKEN);
    useEffect(() => {
        // 토큰 있으면 /admin 이동
        if (token) {
            navigate(Const.URL_ADMIN);
        }
        return;
    }, [token]);
    const login = (e) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POST,
            appPath: `/admin/login`,
            appQuery: {
                "userName": userName,
                "passwd": password
            },
            userToken: "",
            feils: [],
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                localStorage.setItem(Const.TOKEN, data.body.token);
                navigate(Const.URL_ADMIN);
            }
            else {
                alert(data.body.message);
            }
        }
    });
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "login-container" }, { children: _jsxs("div", Object.assign({ className: "login-box" }, { children: [_jsx("img", { src: require("/static/img/logo-color.webp"), alt: "\uB85C\uACE0", className: "logo" }), _jsxs("form", Object.assign({ className: "login-section" }, { children: [_jsx("label", Object.assign({ className: "login-label", htmlFor: "username" }, { children: "\uC0AC\uC6A9\uC790\uBA85 \uB610\uB294 \uC774\uBA54\uC77C \uC8FC\uC18C" })), _jsx("input", { type: "id", id: "username", placeholder: "\uC544\uC774\uB514 \uC785\uB825", required: true, value: userName, onChange: (e) => setUserName(e.target.value) }), _jsx("label", Object.assign({ className: "login-label", htmlFor: "password" }, { children: "\uBE44\uBC00\uBC88\uD638" })), _jsx("div", Object.assign({ className: "password-wrap" }, { children: _jsx("input", { type: "password", id: "password", placeholder: "\uBE44\uBC00\uBC88\uD638 \uC785\uB825", required: true, value: password, onChange: (e) => setPassword(e.target.value) }) })), _jsx("button", Object.assign({ type: "button", className: "login-btn", onClick: (e) => login(e) }, { children: "\uB85C\uADF8\uC778" }))] })), _jsx("a", Object.assign({ href: "/main", className: "back" }, { children: "\uB274\uC6D0 \uD648\uD398\uC774\uC9C0\uB85C \uC774\uB3D9" }))] })) })) }));
}
